



























import { TaskOpinions_GetList, TaskUserCommitsItem } from '@/api';
import Vue, { PropType } from 'vue';
import moment from 'moment';
import AddNotationModal from './add-notation-modal.vue';

interface Notation {
  mark: number;
  status: number;
  remark: string;
  taskCommitId: string;
  taskId: string;
  imageUrl: string;
  creationTime: string;
  createUserId: string;
  id: string;
}
export default Vue.extend({
  components: { AddNotationModal },
  props: {
    fileId: { type: String },
    commit: { type: Object as PropType<TaskUserCommitsItem> },
    spdApi: { type: Object },
  },
  data() {
    return {
      remark: '',
      imageUrl: '',
      visible: false,
      notationName: '',
      base64PImg: '',
      notations: [] as Notation[],
      onlyShow: false,
    };
  },
  methods: {
    async getNotations() {
      console.log(this.commit);

      const res: any = await TaskOpinions_GetList({
        taskId: this.commit?.commitInfo?.taskId,
        commitId: this.commit?.commitInfo?.id,
      });
      if (res.success) {
        this.notations = res.data;
      }
    },
    checkNotation(notation: Notation) {
      this.onlyShow = true;
      this.base64PImg = notation.imageUrl;
      this.visible = true;
    },
  },
  watch: {
    commit: {
      handler(val) {
        if (!val.commitInfo) {
          this.notations = [];
        }
        this.getNotations();
      },
      immediate: true,
    },
  },
  filters: {
    formatTime(val) {
      if (!val) return '';
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
});
